/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { productSchema } from "./productSchema.ts";

export const productsListQueryAttachLogsSchema = z.boolean().optional().default(false).describe("Отобразить логи причин скипа элементов номенкулатуры");

export const productsListQueryCategorySchema = z.uuid().optional();

export const productsListQueryGroupSchema = z.uuid().optional();

export const productsListQueryNameSchema = z.string().optional();

export const productsListPathOrgUnitIdSchema = z.uuid();

export const productsListQueryTagsSchema = z.array(z.string()).optional().describe("Multiple values may be separated by commas.");

export const productsListStatus200Schema = z.array(productSchema);

export const productsListResponseSchema = productsListStatus200Schema;
